import Errors from "@shared/errors";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

let shoppingStoreCart = window.localStorage.getItem("shoppingStoreCart");
let shoppingStoreCartCount = window.localStorage.getItem("shoppingStoreCartCount");

const initialState = () => {
    return {
        showCart: false,
        paymentStatus: "",
        productsStatus: "",
        shoppingCart: shoppingStoreCart ? JSON.parse(shoppingStoreCart) : [],
        shoppingCartCount: shoppingStoreCartCount ? parseInt(shoppingStoreCartCount) : 0,
        venues: [],
        categories: [],
        products: [],
        productsErrors: new Errors(),
        shoppingErrors: new Errors(),
        paymentErrors: new Errors(),
    };
};

const state = {
    initialState: initialState,
    ...initialState(),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
